// extracted by mini-css-extract-plugin
export default {"height100":"MainContentArea_height100__0PfGl"};